export const REQUEST_VARIATIONS = 'REQUEST_VARIATIONS';
export const RECEIVE_VARIATIONS = 'RECEIVE_VARIATIONS';
